module.exports = __webpack_public_path__ + "static/media/2.77358974.jpeg";